<template>
  <div class="row">
    <div class="row"></div>
    <div class="col s12 z-depth-1 white">
      <div v-if="motors.length === 0 && !loading" class="row">
      No motors
      </div>
      <div v-if="!loading && getExistenceMotorsWithoutUniqueId()" class="row">
      One or more motors do(es) not have required uniqueId. Cannot configure alarm settings
      </div>
      <div v-if="!getExistenceMotorsWithoutUniqueId()" class="row" style="margin-bottom:0px;" v-for="(item, index) in motors" :key="index" >
        <div class="col s12">
          <h6> {{ $t('views.switch.engines') }} {{item.Name}}</h6>
          <!-- headers -->
          <div class="row no-margin-bottom" v-if="getSettingsForMotor(item.UniqueId).length > 0 && !loading">
            <div class="col s2"><strong>{{ $t('views.switch.alarmsettings.algorithm') }}</strong></div>
            <div class="col s2"><strong>{{ $t('views.switch.alarmsettings.temperature') }}</strong></div>
            <div class="col s2"><strong>{{ $t('views.switch.alarmsettings.section') }}</strong></div>
            <div class="col s1"><strong>{{ $t('views.switch.alarmsettings.sectionstarttime') }}</strong></div>
            <div class="col s1"><strong>{{ $t('views.switch.alarmsettings.sectionendtime') }}</strong></div>
            <div class="col s1"><strong>{{ $t('views.switch.alarmsettings.direction') }}</strong></div>
            <div class="col s2"><strong>{{ $t('views.switch.alarmsettings.start') }}</strong></div>
            <div class="col s1" v-show="false"><strong>Sensitivity percentage</strong></div>
            <!-- <div class="col s1">Active</div> -->
          </div>
          <div class="row" v-if="getSettingsForMotor(item.UniqueId).length === 0 && !loading">
            <div class="col s4">
              {{ $t('views.switch.alarmsettings.motor') }} {{item.Name}} {{ $t('views.switch.alarmsettings.nosettings') }}
            </div>
          </div>
          <!-- settings -->
          <div v-for="(settings, index) in getSettingsForMotor(item.UniqueId)" :key="settings.SmartReferenceSettingId" :class="{'stripes': index % 2 === 0}" class="row small">
            <!-- algorithm -->
            <div class="col s2">
              <select :class="{'red': settings.invalid && !settings.SmartReferenceAlgorithmId}" v-model="settings.SmartReferenceAlgorithmId" class="select-s2 browser-default small-contents">
                <option v-for="(value) in filterSmartReferenceSettingsAlgorithms" :key="value.SmartReferenceAlgorithmId" :value="value.SmartReferenceAlgorithmId">{{value.Name}}</option>
              </select>
            </div>
            <!-- temperature -->
            <div class="col s2">
              <select :class="{'red': settings.invalid && !settings.SmartReferenceTemperatureBinGroupId}" v-model="settings.SmartReferenceTemperatureBinGroupId" class="select-s2 browser-default small-contents">
                <option v-for="(value) in smartReferenceSettingsTemperatureBinGroups" :key="value.SmartReferenceTemperatureBinGroupId" :value="value.SmartReferenceTemperatureBinGroupId">{{value.Name}}</option>
              </select>
            </div>
            <!-- section -->
            <div class="col s2">
              <select :class="{'red': settings.invalid && !settings.SmartReferenceSection.SmartReferenceSectionTypeId}" v-model="settings.SmartReferenceSection.SmartReferenceSectionTypeId" class="select-s2 browser-default small-contents">
                <option v-for="(value) in smartReferenceSettingsSectionTypes" :key="value.SmartReferenceSectionTypeId" :value="value.SmartReferenceSectionTypeId">{{value.Name}}</option>
              </select>
            </div>
              <!-- section start -->
            <div class="col s1">
              <input type="number"
              :disabled="settings.SmartReferenceSection.SmartReferenceSectionTypeId === 1"
              v-model="settings.SmartReferenceSection.StartTime"
              @change="settings.SmartReferenceSection.StartTime=Math.max(settings.SmartReferenceSection.StartTime, 0)"
              onkeydown="javascript: return (event.keyCode == 69 || event.keyCode == 189) ? false : true" class="small-contents" min="0">
            </div>
            <!-- section end -->
            <div class="col s1">
              <input type="number"
              :disabled="settings.SmartReferenceSection.SmartReferenceSectionTypeId === 1"
              v-model="settings.SmartReferenceSection.EndTime"
              @change="settings.SmartReferenceSection.EndTime=Math.max(settings.SmartReferenceSection.EndTime, 0)"
              onkeydown="javascript: return (event.keyCode == 69 || event.keyCode == 189) ? false : true" class="small-contents" min="0">
            </div>
            <!-- direction -->
            <div class="col s1">
              <select :class="{'red': settings.invalid && settings.Direction == null}" v-model="settings.Direction" class="select-s1 browser-default small-contents">
                <option v-for="(value) in directions" :key="value.key" :value="value.key">{{value.direction}}</option>
              </select>
            </div>
            <!-- start -->
            <div class="col s2">
              <input :class="{'red': settings.invalid && !settings.StartFrom}" type="date" class="small-contents" :value="settings.StartFrom && settings.StartFrom.split('T')[0]"
                     @input="settings.StartFrom = formatDate($event)">
            </div>
            <!-- sensitivity -->
            <div class="col s1" v-show="false">
              <input :class="{'red': settings.invalid && !settings.Sensitivity}" type="number" v-model="settings.Sensitivity" @change="settings.Sensitivity=Math.max(Math.min(settings.Sensitivity, 100),0)" onkeydown="javascript: return (event.keyCode == 69 || event.keyCode == 189) ? false : true" class="small-contents" min="0" max="100">
            </div>
            <!-- active -->
            <div class="col s1">
              <label>
                <input type="checkbox" v-model="settings.IsActive">
                <span></span>
              </label>
            </div>
            <!-- remove -->
            <div class="col s1 right">
              <a class="component-word-margin small-contents" href="#!" @click.prevent.stop="removeSetting(settings)">{{ $t('views.switch.alarmsettings.remove') }}</a>
            </div>
          </div>
        </div>
        <!-- add -->
        <div class="row" style="margin-bottom:5px;">
          <div class="col s11">
            <a class="component-word-margin small small-contents" style="margin-left: 10px;" href="#!" @click.prevent.stop="addSetting(item.UniqueId, item.Name)">{{ $t('views.switch.alarmsettings.add') }}</a>
          </div>
        </div>
        <!-- save -->
        <div class="row" style="margin-right:5px;margin-bottom:5px;">
          <div class="col s3 offset-s8">
            <div v-if="item.invalid">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Please fill in required fields</div>
          </div>
          <div class="col s1">
            <a class="waves-effect waves-light btn-small right" @click="save(item)">{{ $t('views.switch.alarmsettings.save') }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="row"></div>
    <!-- {{this.smartReferenceSettings}} -->
    <div class="col s12 z-depth-1 white">
      <!--  Do not want to show this error for customers without Position sensor.
      <div v-if="positionsensors.length === 0 && !loading" class="row">
      No position Sensors
      </div>
      -->
      <!-- This check seems to be something from the past as well, didn't rewrite this to Position sensor.
      <div v-if="!loading && getExistenceMotorsWithoutUniqueId()" class="row">
      One or more motors do(es) not have required uniqueId. Cannot configure alarm settings
      </div>
      -->
      <div v-if="positionsensors.length >0" class="row" style="margin-bottom:20px;" v-for="(item, index) in positionsensors" :key="index" >
        <div class="col s12">
          <h6>{{ $t('views.switch.positionsensor') }} {{getSensorName(item.RailObjectId)}}</h6>
          <!-- headers -->
          <div class="row no-margin-bottom" v-if="getSettingsForPositionSensor(item.RailObjectId).length > 0 && !loading">
            <div class="col s2"><strong>{{ $t('views.switch.alarmsettings.algorithm') }}</strong></div>
            <div class="col s2"><strong>{{ $t('views.switch.alarmsettings.temperature') }}</strong></div>
            <div class="col s1"><strong>{{ $t('views.switch.alarmsettings.direction') }}</strong></div>
            <div class="col s2"><strong>{{ $t('views.switch.alarmsettings.start') }}</strong></div>
            <div class="col s5">
            <div class="col s4"><strong>{{ $t('views.switch.alarmsettings') }}</strong></div>
            <div class="col s3"><strong>{{ $t('views.switch.value') }}</strong></div>
            <div class="col s1"><strong>{{ $t('views.switch.alarmsettings.remove') }}</strong></div>
           </div>
           <div class="col s1" v-show="false"><strong>{{ $t('views.switch.enabled') }}</strong></div>
            <div class="col s1" v-show="false"><strong>Sensitivity percentage</strong></div>
            <!-- <div class="col s1">Active</div> -->
          </div>
          <div class="row" v-if="getSettingsForPositionSensor(item.RailObjectId).length === 0 && !loading">
            <div class="col s4">
              {{ $t('views.switch.positionsensor') }} {{getSensorName(item.RailObjectId)}} {{ $t('views.switch.hasnosettings')}}
            </div>
          </div>
          <!-- settings -->

          <div v-for="(settings, index) in getSettingsForPositionSensor(item.RailObjectId)" :key="settings.SmartReferenceSettingId" :class="{'stripes': index % 2 === 0}" class="row small">

          <!-- <div v-for="(settings) in getSettingsForPositionSensor(item.RailObjectId)" :key="settings.SmartReferenceSettingId" class="row small no-margin-bottom"> -->

            <!-- algorithm -->
            <div class="col s2">
              <select :class="{'red': settings.invalid && !settings.SmartReferenceAlgorithmId}" v-model="settings.SmartReferenceAlgorithmId" class="select-s2 browser-default small-contents" :disabled="settings.SmartReferenceAlgorithmId =7">
                <option v-for="(value) in smartReferenceSettingsAlgorithms" :key="value.SmartReferenceAlgorithmId" :value="value.SmartReferenceAlgorithmId">{{value.Name}}</option>
              </select>
            </div>
            <!-- temperature -->
            <div class="col s2">
              <select :class="{'red': settings.invalid && !settings.SmartReferenceTemperatureBinGroupId}" v-model="settings.SmartReferenceTemperatureBinGroupId" class="select-s2 browser-default small-contents" :disabled="settings.SmartReferenceTemperatureBinGroupId =3">
                <option v-for="(value) in smartReferenceSettingsTemperatureBinGroups" :key="value.SmartReferenceTemperatureBinGroupId" :value="value.SmartReferenceTemperatureBinGroupId" >{{value.Name}}</option>
              </select>
            </div>
            <!-- direction -->
            <div class="col s1">
              <select :class="{'red': (settings.invalid && settings.Direction == null) || directionsDuplicate (item.RailObjectId, index,settings.Direction)  }" v-model="settings.Direction" class="select-s1 browser-default small-contents">
                <option v-for="(value) in directions" :key="value.key" :value="value.key">{{value.direction}}</option>
              </select>
            </div>
            <!-- start -->
            <div class="col s2">
              <input :class="{'red': settings.invalid && !settings.StartFrom}" type="date" class="small-contents" :value="settings.StartFrom && settings.StartFrom.split('T')[0]"
                     @input="settings.StartFrom = formatDate($event)">
            </div>
            <!-- sensitivity -->
            <div class="col s1" v-show="false">
              <input :class="{'red': settings.invalid && !settings.Sensitivity}" type="number" v-model="settings.Sensitivity" @change="settings.Sensitivity=Math.max(Math.min(settings.Sensitivity, 100),0)" onkeydown="javascript: return (event.keyCode == 69 || event.keyCode == 189) ? false : true" class="small-contents" min="0" max="100">
            </div>
            <!-- alarms and warnings -->
            <div class="col s5">
              <div class="row no-margin-bottom" v-for="(value) in orderedBy(settings.SmartReferenceValue)" :key="value.SmartReferenceValueTypeId" :value="value.Value">
                <div class="col s6" style="margin-left: 10px;">{{getPositionSensorSettingName(value.SmartReferenceValueTypeId)}}</div>
                <div class="col s1"><input type="number" v-model="value.Value" :class="{ 'invalidInput': isValuenValid(item.RailObjectId, index,value.SmartReferenceValueTypeId, value.Value) }"></div>
                <div class="col s1">
                <a class="component-word-margin small small-contents" style="margin-left: 1px;background-color: red ; padding:2px; color:white; border: solid 2px black; border-radius: 2px;" href="#!" @click.prevent.stop="removeValue(value)">⚊</a>
                </div>
              </div>
              <div v-if="settings.SmartReferenceValue.length <4" class="row" style="margin-bottom:0px;">
                <a class="component-word-margin small small-contents" style="margin-left: 1px;background-color: black;padding:2px; color:white; border: solid 2px black; border-radius: 2px;" href="#!" @click.prevent.stop="addValues(settings)">✚</a>
              </div>
            </div>
            <!-- active -->
            <div class="col s1">
              <label class="checkbox-small">
                <input type="hidden" v-model="settings.IsActive">
                <span class="checkbox-small body1"></span>
              </label>
            </div>
            <!-- remove -->
            <div class="col s1 right">
              <a class="component-word-margin small-contents" href="#!" @click.prevent.stop="removeSetting(settings)">{{ $t('views.switch.alarmsettings.remove') }}</a>
            </div>
          </div>
        </div>
        <!-- add -->
        <div class="row" style="margin-bottom:5px;">
          <div class="col s11">
            <a class="component-word-margin small small-contents" style="margin-left: 10px;" href="#!" @click.prevent.stop="addPositionSensorSetting(getSensorUniqueID(item.RailObjectId), getSensorName(item.RailObjectId))">{{ $t('views.switch.alarmsettings.add') }}</a>
          </div>
        </div>
        <!-- save -->
        <div class="row" style="margin-right:5px;margin-bottom:5px;">
          <div class="col s3 offset-s8">
            <div v-if="item.invalid">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('views.switch.alarmsettings.notsavederror') }} </div>
          </div>
          <div class="col s1">
            <a class="waves-effect waves-light btn-small right" @click="savePositionSensor(item)">{{ $t('views.switch.alarmsettings.save') }}</a>
          </div>
        </div>
        <hr>
      </div>
    </div>

    <!-- Oil Pressure Settings (RFLI only, which is RegionId 210) -->
    <div class="col s12 z-depth-1 white">
      <div v-if="railObject.RegionId == 210 && oilPressureSensors.length > 0 && !loading" class="row" style="margin-bottom:20px;" v-for="(item, index) in oilPressureSensors" :key="index" >
        <div class="col s12">
          <h6>Oil Pressure - {{getSensorName(item.RailObjectId)}}</h6>
          <!-- headers -->
          <div class="row no-margin-bottom" v-if="getSettingsForOilPressureSensor(item.RailObjectId).length > 0 && !loading">
            <div class="col s2"><strong>{{ $t('views.switch.alarmsettings.algorithm') }}</strong></div>
            <div class="col s2"><strong>{{ $t('views.switch.alarmsettings.temperature') }}</strong></div>
            <div class="col s1"><strong>{{ $t('views.switch.alarmsettings.direction') }}</strong></div>
            <div class="col s2"><strong>{{ $t('views.switch.alarmsettings.start') }}</strong></div>
            <div class="col s5">
              <div class="col s8"><strong>{{ $t('views.switch.alarmsettings') }}</strong></div>
              <div class="col s1" style="padding-left: 25px;"><strong>{{ $t('views.switch.value') }}</strong></div>
            </div>
          </div>
          <div class="row" v-if="getSettingsForOilPressureSensor(item.RailObjectId).length === 0 && !loading">
            <div class="col s4">
              {{ $t('views.switch.positionsensor') }} {{getSensorName(item.RailObjectId)}} {{ $t('views.switch.hasnosettings')}}
            </div>
          </div>

          <!-- settings -->
          <div v-for="(settings, index) in getSettingsForOilPressureSensor(item.RailObjectId)" :key="settings.SmartReferenceSettingId" :class="{'stripes': index % 2 === 0}" class="row small">

            <!-- 1.algorithm -->
            <div class="col s2">
              <select :class="{'red': settings.invalid && !settings.SmartReferenceAlgorithmId}" v-model="settings.SmartReferenceAlgorithmId" class="select-s2 browser-default small-contents" :disabled="settings.SmartReferenceAlgorithmId =8">
                <option v-for="(value) in smartReferenceSettingsAlgorithms" :key="value.SmartReferenceAlgorithmId" :value="value.SmartReferenceAlgorithmId">{{value.Name}}</option>
              </select>
            </div>
            <!-- 2.temperature -->
            <div class="col s2">
              <select :class="{'red': settings.invalid && !settings.SmartReferenceTemperatureBinGroupId}" v-model="settings.SmartReferenceTemperatureBinGroupId" class="select-s2 browser-default small-contents" :disabled="settings.SmartReferenceTemperatureBinGroupId =3">
                <option v-for="(value) in smartReferenceSettingsTemperatureBinGroups" :key="value.SmartReferenceTemperatureBinGroupId" :value="value.SmartReferenceTemperatureBinGroupId" >{{value.Name}}</option>
              </select>
            </div>
            <!-- 3.direction -->
            <div class="col s1">
              <select :class="{'red': (settings.invalid && settings.Direction == null) || directionsDuplicate (item.RailObjectId, index,settings.Direction)  }" v-model="settings.Direction" class="select-s1 browser-default small-contents">
                <option v-for="(value) in directions" :key="value.key" :value="value.key">{{value.direction}}</option>
              </select>
            </div>
            <!-- 4.start -->
            <div class="col s2">
              <input :class="{'red': settings.invalid && !settings.StartFrom}" type="date" class="small-contents" :value="settings.StartFrom && settings.StartFrom.split('T')[0]"
                     @input="settings.StartFrom = formatDate($event)">
            </div>
            <!-- alarms and warnings -->
            <div class="col s5">
              <div class="row" style="height: 15px;" v-for="(value) in orderedBy(settings.SmartReferenceValue)" :key="value.SmartReferenceValueTypeId" :value="value.Value">
                <div class="col s8" style="margin-left: 10px;">{{getOilPressureSensorSettingName(value.SmartReferenceValueTypeId)}}</div>
                <div class="col s1"><input type="number" v-model="value.Value" :class="{ 'invalidInput': isValuenValidOil(item.RailObjectId, index,value.SmartReferenceValueTypeId, value.Value) }"></div>
                <div class="col s1">
                  <a class="component-word-margin small small-contents" style="margin-left: 1px;background-color: red ; padding:2px; color:white; border: solid 2px black; border-radius: 2px;" href="#!" @click.prevent.stop="removeValue(value)">⚊</a>
                </div>
              </div>
              <div v-if="settings.SmartReferenceValue.length <4" class="row" style="margin-bottom:0px;">
                <div class="col s8"></div>
                <div class="col s1"></div>
                <div class="col s1">
                  <a class="col component-word-margin small small-contents" style="margin-left: 11px;background-color: black;padding:2px; color:white; border: solid 2px black; border-radius: 2px;" href="#!" @click.prevent.stop="addValuesOil(settings)">✚</a>
                </div>
              </div>
            </div>
            <!-- active -->
            <div class="col s1">
              <label class="checkbox-small">
                <input type="hidden" v-model="settings.IsActive">
                <span class="checkbox-small body1"></span>
              </label>
            </div>
            <!-- remove -->
            <div class="col s1 right">
              <a class="component-word-margin small-contents" href="#!" @click.prevent.stop="removeSetting(settings)">{{ $t('views.switch.alarmsettings.remove') }}</a>
            </div>
          </div>
        </div>
        <!-- add -->
        <div class="row" style="margin-bottom:5px;">
          <div class="col s11">
            <a class="component-word-margin small small-contents" style="margin-left: 10px;" href="#!" @click.prevent.stop="addOilPressureSensorSetting(getSensorUniqueID(item.RailObjectId), getSensorName(item.RailObjectId))">{{ $t('views.switch.alarmsettings.add') }}</a>
          </div>
        </div>
        <!-- save -->
        <div class="row" style="margin-right:5px;margin-bottom:5px;">
          <div class="col s3 offset-s8">
            <div v-if="item.invalid">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('views.switch.alarmsettings.notsavederror') }} </div>
          </div>
          <div class="col s1">
            <a class="waves-effect waves-light btn-small right" @click="saveOilPressureSensor(item)">{{ $t('views.switch.alarmsettings.save') }}</a>
          </div>
        </div>
        <hr>
      </div>
    </div>

  </div>
</template>

<script>
import SmartReferenceApi from '../../services/api/switch/SmartReferenceApi.js'
import AlarmService from '@/services/AlarmService'
import _ from 'lodash'
import moment from 'moment'
import Vue from 'vue'

export default {
  components: {
  },
  props: {
    railObject: {
      type: Object,
      default: () => {
      }
    }
  },
  name: 'alarmsettings',
  data () {
    return {
      smartReferenceSettings: [],
      smartReferenceSettingsAlgorithms: [],
      smartReferenceSettingsTemperatureBinGroups: [],
      smartReferenceSettingsSectionTypes: [],
      smartReferenceSettingsAlarmTypes: [],
      motors: [],
      loading: true,
      directions: [{key: 'false', direction: this.$t('views.switch.alarmsettings.normal')}, {key: 'true', direction: this.$t('views.switch.alarmsettings.reverse')}],
      positionsensors: [],
      oilPressureSensors: []
    }
  },
  computed: {
    filterSmartReferenceSettingsAlgorithms: function () {
      return this.smartReferenceSettingsAlgorithms.filter(f => f.SmartReferenceAlgorithmId !== 7 && f.SmartReferenceAlgorithmId !== 8) // filter out position and oil pressure sensors for the normal motor alarms
    }
  },
  beforeCreate: function () {
  },
  created: function () {
    this.getSensor()
    this.getOilPressureSensors()
    this.getSmartReferenceData()
  },
  mounted: function () {
    let elems = document.querySelectorAll('select')
    M.FormSelect.init(elems)

    let collapsible = document.querySelectorAll('.collapsible.expandable')
    M.Collapsible.init(collapsible, { accordion: false })
  },
  beforeDestroy: function () {
  },
  methods: {
    orderedBy: function (list) {
      return _.orderBy(list, 'SmartReferenceValueTypeId')
    },
    isInValidItem: function (objIdx) {
      var positionvalues = []
      objIdx.SmartReferenceValue.forEach(x => {
        positionvalues[x.SmartReferenceValueTypeId] = Number(x.Value)
      })
      if (positionvalues[16] !== undefined && positionvalues[15] !== undefined) {
        if (positionvalues[16] > positionvalues[15]) {
          return true
        }
      }
      if (positionvalues[17] !== undefined) {
        if (positionvalues[16] !== undefined) {
          if (positionvalues[17] > positionvalues[16]) {
            return true
          }
        } else {
          if (positionvalues[16] !== undefined) {
            if (positionvalues[17] > positionvalues[15]) {
              return true
            }
          }
        }
      }
      if (positionvalues[18] !== undefined) {
        if (positionvalues[17] !== undefined) {
          if (positionvalues[18] > positionvalues[17]) {
            return true
          }
        } else {
          if (positionvalues[16] !== undefined) {
            if (positionvalues[18] > positionvalues[16]) {
              return true
            }
          } else {
            if (positionvalues[16] !== undefined) {
              if (positionvalues[18] > positionvalues[15]) {
                return true
              }
            }
          }
        }
      }
      return false
    },
    isInValidItemOil: function (objIdx) {
      var oilPressureValues = []
      objIdx.SmartReferenceValue.forEach(x => {
        oilPressureValues[x.SmartReferenceValueTypeId] = Number(x.Value)
      })

      // Zero checks
      for (var i = 99; i <= 106; i++) {
        if (oilPressureValues[i] !== undefined && oilPressureValues[i] <= 0) {
          return true
        }
      }

      // Alarm factor (up) Oil Pressure Check - Movement pressure
      if (oilPressureValues[103] !== undefined && oilPressureValues[104] !== undefined) {
        if (oilPressureValues[103] < oilPressureValues[104]) { // Alarm factor (up) < Warning factor (up)
          return true
        }
      }

      // Warning factor (up) Oil Pressure Check - Movement pressure
      if (oilPressureValues[104] !== undefined && oilPressureValues[103] !== undefined) {
        if (oilPressureValues[104] > oilPressureValues[103]) { // Warning factor (up) > Alarm factor (up)
          return true
        }
      }

      // Warning factor (down) Oil Pressure Check - Movement pressure
      if (oilPressureValues[105] !== undefined && oilPressureValues[106] !== undefined) {
        if (oilPressureValues[105] > oilPressureValues[106]) { // Warning factor (down) > Alarm factor (down)
          return true
        }
      }

      // Alarm factor (down) Oil Pressure Check - Movement pressure
      if (oilPressureValues[106] !== undefined && oilPressureValues[105] !== undefined) {
        if (oilPressureValues[106] < oilPressureValues[105]) { // Alarm factor (down) < Warning factor (down)
          return true
        }
      }

      return false
    },
    directionsDuplicate: function (id, idx, val) {
      var obj = this.getSettingsForPositionSensor(id)
      if (obj.length > 2) {
        return true
      }
      let cntTrue = 0
      let cntFalse = 0
      obj.forEach(x => {
        if (String(x.Direction) === 'true') {
          cntTrue = cntTrue + 1
        }
        if (String(x.Direction) === 'false') {
          cntFalse = cntFalse + 1
        }
      })
      // console.log('--> cntTrue: ' + cntTrue + ' cntFalse: ' + cntFalse + ' =>' + val)
      if (cntTrue > 1) {
        return true
      }
      if (cntFalse > 1) {
        return true
      }
      return false
    },
    isValuenValid: function (id, idx, varNr, val) {
      var obj = this.getSettingsForPositionSensor(id)
      var positionvalues = []
      obj[idx].SmartReferenceValue.forEach(x => {
        positionvalues[x.SmartReferenceValueTypeId] = Number(x.Value)
      })
      switch (varNr) {
        case 16:
          if (positionvalues[16] !== undefined && positionvalues[15] !== undefined) {
            if (positionvalues[16] > positionvalues[15]) {
              // console.log(idx + ' : ' + positionvalues[16] + ' > ' + positionvalues[15])
              return true
            }
          }
          return false
        case 17:
          if (positionvalues[17] !== undefined) {
            if (positionvalues[16] !== undefined) {
              if (positionvalues[17] > positionvalues[16]) {
                // console.log(idx + ' : ' + positionvalues[17] + ' > ' + positionvalues[16])
                return true
              }
            } else {
              if (positionvalues[15] !== undefined) {
                if (positionvalues[17] > positionvalues[15]) {
                  // console.log(idx + ' : ' + positionvalues[17] + ' > ' + positionvalues[15])
                  return true
                }
              }
            }
          }
          return false
        case 18:
          if (positionvalues[18] !== undefined) {
            if (positionvalues[17] !== undefined) {
              if (positionvalues[18] > positionvalues[17]) {
                // console.log(idx + ' : ' + positionvalues[18] + ' > ' + positionvalues[17])
                return true
              }
            } else {
              if (positionvalues[16] !== undefined) {
                if (positionvalues[18] > positionvalues[16]) {
                  // console.log(idx + ' : ' + positionvalues[18] + ' > ' + positionvalues[16])
                  return true
                }
              } else {
                if (positionvalues[15] !== undefined) {
                  if (positionvalues[18] > positionvalues[15]) {
                    // console.log(idx + ' : ' + positionvalues[18] + ' > ' + positionvalues[15])
                    return true
                  }
                }
              }
            }
          }
          return false
      }
      return false
    },
    isValuenValidOil: function (id, idx, varNr, val) {
      var obj = this.getSettingsForOilPressureSensor(id)
      var oilPressureValues = []
      obj[idx].SmartReferenceValue.forEach(x => {
        oilPressureValues[x.SmartReferenceValueTypeId] = Number(x.Value)
      })

      // All values should be > 0
      if (oilPressureValues[varNr] !== undefined && oilPressureValues[varNr] <= 0) {
        return true
      }

      switch (varNr) {
        case 103: // Alarm factor (up) Oil Pressure Check - Movement pressure
          if (oilPressureValues[103] !== undefined && oilPressureValues[104] !== undefined) {
            if (oilPressureValues[103] < oilPressureValues[104]) { // Alarm factor (up) < Warning factor (up)
              return true
            }
          }
          return false

        case 104: // Warning factor (up) Oil Pressure Check - Movement pressure
          if (oilPressureValues[104] !== undefined && oilPressureValues[103] !== undefined) {
            if (oilPressureValues[104] > oilPressureValues[103]) { // Warning factor (up) > Alarm factor (up)
              return true
            }
          }
          return false

        case 105: // Warning factor (down) Oil Pressure Check - Movement pressure
          if (oilPressureValues[105] !== undefined && oilPressureValues[106] !== undefined) {
            if (oilPressureValues[105] > oilPressureValues[106]) { // Warning factor (down) > Alarm factor (down)
              return true
            }
          }
          return false

        case 106: // Alarm factor (down) Oil Pressure Check - Movement pressure
          if (oilPressureValues[106] !== undefined && oilPressureValues[105] !== undefined) {
            if (oilPressureValues[106] < oilPressureValues[105]) { // Alarm factor (down) < Warning factor (down)
              return true
            }
          }
          return false
      }
      return false
    },
    async save (motor) {
      try {
        let settings = _.filter(this.smartReferenceSettings, item => item.UniqueId === motor.UniqueId)
        var valid = true
        settings.forEach(s => {
          if (!s.SmartReferenceAlgorithmId || !s.SmartReferenceTemperatureBinGroupId ||
          !s.SmartReferenceSection.SmartReferenceSectionTypeId || s.Direction == null || !s.StartFrom ||
           !s.Sensitivity) {
            Vue.set(s, 'invalid', true)
            valid = false
          } else {
            Vue.set(s, 'invalid', false)
          }
        })
        Vue.set(motor, 'invalid', !valid)
        setTimeout(() => { Vue.set(motor, 'invalid', false) }, 3000)
        if (valid === true) {
          settings = _.filter(this.smartReferenceSettings, item => item.UniqueId === motor.UniqueId)
          // API returns the save setting. Remove the old setting from the list and concat it with the new setting to get a complete list
          let returnedSettings = await SmartReferenceApi.saveSmartReferenceSettings(settings, motor.RailObjectId)
          let remainingSettings = _.filter(this.smartReferenceSettings, item => item.UniqueId !== motor.UniqueId)
          let newSettings = remainingSettings.concat(returnedSettings)
          Vue.set(this, 'smartReferenceSettings', newSettings)
          // returnedSettings.forEach(s => {
          //   this.smartReferenceSettings.push(s)
          // })
          this.railObject.AlarmSettingsAreDefault = false
          this.$notify({
            group: 'alerts',
            type: 'success',
            title: 'alarm settings saved',
            duration: 1000,
            speed: 1000
          })
        }
      } catch (e) {
        this.$notify({
          group: 'alerts',
          type: 'error',
          title: 'alarm settings not saved',
          text: '' + e,
          duration: 1000,
          speed: 1000
        })
      }
    },
    async savePositionSensor (position) {
      try {
        let uid = this.getSensorUniqueID(position.RailObjectId)
        let settings = _.filter(this.smartReferenceSettings, item => item.UniqueId === uid)
        var valid = true

        var cntFalse = 0
        var cntTrue = 0
        settings.forEach(s => {
          if (s.Direction != null) {
            if (String(s.Direction) === 'true') {
              cntTrue = cntTrue + 1
            }
            if (String(s.Direction) === 'false') {
              cntFalse = cntFalse + 1
            }
          }
          if (!s.SmartReferenceAlgorithmId || !s.SmartReferenceTemperatureBinGroupId ||
          !s.SmartReferenceSection.SmartReferenceSectionTypeId || s.Direction == null || !s.StartFrom ||
           !s.Sensitivity || this.isInValidItem(s) || cntFalse > 1 || cntTrue > 1 || (cntFalse + cntTrue) > 2) {
            Vue.set(s, 'invalid', true)
            valid = false
          } else {
            Vue.set(s, 'invalid', false)
          }
        })
        Vue.set(position, 'invalid', !valid)
        setTimeout(() => { Vue.set(position, 'invalid', false) }, 3000)
        if (valid === true) {
          let uid = this.getSensorUniqueID(position.RailObjectId)
          settings = _.filter(this.smartReferenceSettings, item => item.UniqueId === uid)
          // API returns the save setting. Remove the old setting from the list and concat it with the new setting to get a complete list
          let returnedSettings = await SmartReferenceApi.saveSmartReferenceSettings(settings, position.RailObjectId)
          let remainingSettings = _.filter(this.smartReferenceSettings, item => item.UniqueId !== uid)
          let newSettings = remainingSettings.concat(returnedSettings)
          Vue.set(this, 'smartReferenceSettings', newSettings)
          // returnedSettings.forEach(s => {
          //   this.smartReferenceSettings.push(s)
          // })
          this.railObject.AlarmSettingsAreDefault = false
          this.$notify({
            group: 'alerts',
            type: 'success',
            title: 'alarm settings saved',
            duration: 1000,
            speed: 1000
          })
        }
      } catch (e) {
        this.$notify({
          group: 'alerts',
          type: 'error',
          title: 'alarm settings not saved',
          text: '' + e,
          duration: 1000,
          speed: 1000
        })
      }
    },
    async saveOilPressureSensor (position) {
      try {
        let uid = this.getSensorUniqueID(position.RailObjectId)
        let settings = _.filter(this.smartReferenceSettings, item => item.UniqueId === uid)
        var valid = true

        var cntFalse = 0
        var cntTrue = 0
        settings.forEach(s => {
          if (s.Direction != null) {
            if (String(s.Direction) === 'true') {
              cntTrue = cntTrue + 1
            }
            if (String(s.Direction) === 'false') {
              cntFalse = cntFalse + 1
            }
          }
          if (!s.SmartReferenceAlgorithmId || !s.SmartReferenceTemperatureBinGroupId ||
          !s.SmartReferenceSection.SmartReferenceSectionTypeId || s.Direction == null || !s.StartFrom ||
           !s.Sensitivity || this.isInValidItemOil(s) || cntFalse > 1 || cntTrue > 1 || (cntFalse + cntTrue) > 2) {
            Vue.set(s, 'invalid', true)
            valid = false
          } else {
            Vue.set(s, 'invalid', false)
          }
        })
        Vue.set(position, 'invalid', !valid)
        setTimeout(() => { Vue.set(position, 'invalid', false) }, 3000)
        if (valid === true) {
          let uid = this.getSensorUniqueID(position.RailObjectId)
          settings = _.filter(this.smartReferenceSettings, item => item.UniqueId === uid)
          // API returns the save setting. Remove the old setting from the list and concat it with the new setting to get a complete list
          let returnedSettings = await SmartReferenceApi.saveSmartReferenceSettings(settings, position.RailObjectId)
          let remainingSettings = _.filter(this.smartReferenceSettings, item => item.UniqueId !== uid)
          let newSettings = remainingSettings.concat(returnedSettings)
          Vue.set(this, 'smartReferenceSettings', newSettings)
          this.railObject.AlarmSettingsAreDefault = false
          this.$notify({
            group: 'alerts',
            type: 'success',
            title: 'alarm settings saved',
            duration: 1000,
            speed: 1000
          })
        }
      } catch (e) {
        this.$notify({
          group: 'alerts',
          type: 'error',
          title: 'alarm settings not saved',
          text: '' + e,
          duration: 1000,
          speed: 1000
        })
      }
    },
    addSetting (uniqueId, name) {
      this.smartReferenceSettings.push({
        UniqueId: uniqueId,
        Name: name,
        StartFrom: '',
        IsActive: true,
        SmartReferenceSection: {
          StartTime: null,
          EndTime: null,
          SmartReferenceSectionTypeId: null
        },
        Sensitivity: 1
      })
    },
    addPositionSensorSetting (uniqueId, name) {
      this.smartReferenceSettings.push({
        UniqueId: uniqueId,
        Name: name,
        StartFrom: '',
        IsActive: true,
        SmartReferenceSectionId: 1,
        SmartReferenceSection: {
          StartTime: null,
          EndTime: null,
          SmartReferenceSectionTypeId: 1
        },
        SmartReferenceAlgorithmId: 7,
        SmartReferenceValue: [{
          SmartReferenceValueTypeId: 15,
          Value: 0,
          MeasurementDateTime: moment().format('YYYY-MM-DD')
        },
        {
          SmartReferenceValueTypeId: 16,
          Value: 0,
          MeasurementDateTime: moment().format('YYYY-MM-DD')
        },
        {
          SmartReferenceValueTypeId: 17,
          Value: 0,
          MeasurementDateTime: moment().format('YYYY-MM-DD')
        },
        {
          SmartReferenceValueTypeId: 18,
          Value: 0,
          MeasurementDateTime: moment().format('YYYY-MM-DD')
        }],
        Sensitivity: 1
      })
    },
    getPositionSensorSettingName (id) {
      switch (id) {
        case 15:
          return this.$t('views.switch.positionhighalarm')
        case 16:
          return this.$t('views.switch.positionhighwarning')
        case 17:
          return this.$t('views.switch.positionlowwarning')
        case 18:
          return this.$t('views.switch.positionlowalarm')
        default:
          return 'unknown position sensor name'
      }
    },
    addOilPressureSensorSetting (uniqueId, name) {
      this.smartReferenceSettings.push({
        UniqueId: uniqueId,
        Name: name,
        StartFrom: '',
        IsActive: true,
        SmartReferenceSectionId: 1,
        SmartReferenceSection: {
          StartTime: null,
          EndTime: null,
          SmartReferenceSectionTypeId: 1
        },
        SmartReferenceAlgorithmId: 8, // Oil pressure check
        SmartReferenceValue: [{
          SmartReferenceValueTypeId: 99, // alarmFactorUpOilMaxPressure
          Value: 0,
          MeasurementDateTime: moment().format('YYYY-MM-DD')
        },
        {
          SmartReferenceValueTypeId: 100, // alarmFactorDownOilMaxPressure
          Value: 0,
          MeasurementDateTime: moment().format('YYYY-MM-DD')
        },
        {
          SmartReferenceValueTypeId: 101, // alarmFactorUpOilMovementEnd
          Value: 0,
          MeasurementDateTime: moment().format('YYYY-MM-DD')
        },
        {
          SmartReferenceValueTypeId: 102, // alarmFactorDownOilMovementEnd
          Value: 0,
          MeasurementDateTime: moment().format('YYYY-MM-DD')
        },
        {
          SmartReferenceValueTypeId: 103, // alarmFactorUpOilMovementPressure
          Value: 0,
          MeasurementDateTime: moment().format('YYYY-MM-DD')
        },
        {
          SmartReferenceValueTypeId: 104, // warningFactorUpOilMovementPressure
          Value: 0,
          MeasurementDateTime: moment().format('YYYY-MM-DD')
        },
        {
          SmartReferenceValueTypeId: 105, // warningFactorDownOilMovementPressure
          Value: 0,
          MeasurementDateTime: moment().format('YYYY-MM-DD')
        },
        {
          SmartReferenceValueTypeId: 106, // alarmFactorDownOilMovementPressure
          Value: 0,
          MeasurementDateTime: moment().format('YYYY-MM-DD')
        }],
        Sensitivity: 1
      })
    },
    getOilPressureSensorSettingName (id) {
      switch (id) {
        case 99:
          return 'Alarm factor (up) - Max pressure'
        case 100:
          return 'Alarm factor (down) - Max pressure'
        case 101:
          return 'Alarm factor (up) - Movement end'
        case 102:
          return 'Alarm factor (down) - Movement end'
        case 103:
          return 'Alarm factor (up) - Movement pressure'
        case 104:
          return 'Warning factor (up) - Movement pressure'
        case 105:
          return 'Warning factor (down) - Movement pressure'
        case 106:
          return 'Alarm factor (down) - Movement pressure'
        default:
          return 'Unknown oil pressure sensor name'
      }
    },
    removeSetting: function (setting) {
      let existingObjectIndex = this.smartReferenceSettings.findIndex(s => s === setting)
      if (existingObjectIndex > -1) {
        this.smartReferenceSettings.splice(existingObjectIndex, 1)
      }
    },
    removeValue: function (setting) {
      this.smartReferenceSettings.forEach(s => {
        let existingObjectIndex = s.SmartReferenceValue.findIndex(s => s === setting)
        if (existingObjectIndex > -1) {
          s.SmartReferenceValue.splice(existingObjectIndex, 1)
        }
      })
    },
    addValues: function (setting) {
      let existingObjectIndex = this.smartReferenceSettings.findIndex(s => s === setting)
      if (existingObjectIndex > -1) {
        let ha = _.filter(this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue, item => item.SmartReferenceValueTypeId === 15)
        if (ha.length === 0) {
          this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue.push({
            SmartReferenceValueTypeId: 15,
            Value: 0,
            MeasurementDateTime: moment().format('YYYY-MM-DD')
          })
        }
        let hw = _.filter(this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue, item => item.SmartReferenceValueTypeId === 16)
        if (hw.length === 0) {
          this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue.push({
            SmartReferenceValueTypeId: 16,
            Value: 0,
            MeasurementDateTime: moment().format('YYYY-MM-DD')
          })
        }
        let lw = _.filter(this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue, item => item.SmartReferenceValueTypeId === 17)
        if (lw.length === 0) {
          this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue.push({
            SmartReferenceValueTypeId: 17,
            Value: 0,
            MeasurementDateTime: moment().format('YYYY-MM-DD')
          })
        }
        let la = _.filter(this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue, item => item.SmartReferenceValueTypeId === 18)
        if (la.length === 0) {
          this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue.push({
            SmartReferenceValueTypeId: 18,
            Value: 0,
            MeasurementDateTime: moment().format('YYYY-MM-DD')
          })
        }
      }
    },
    addValuesOil: function (setting) {
      let existingObjectIndex = this.smartReferenceSettings.findIndex(s => s === setting)

      if (existingObjectIndex > -1) {
        let alarmFactorUpOilMaxPressure = _.filter(this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue, item => item.SmartReferenceValueTypeId === 99)
        if (alarmFactorUpOilMaxPressure.length === 0) {
          this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue.push({
            SmartReferenceValueTypeId: 99,
            Value: 0,
            MeasurementDateTime: moment().format('YYYY-MM-DD')
          })
        }

        let alarmFactorDownOilMaxPressure = _.filter(this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue, item => item.SmartReferenceValueTypeId === 100)
        if (alarmFactorDownOilMaxPressure.length === 0) {
          this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue.push({
            SmartReferenceValueTypeId: 100,
            Value: 0,
            MeasurementDateTime: moment().format('YYYY-MM-DD')
          })
        }

        let alarmFactorUpOilMovementEnd = _.filter(this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue, item => item.SmartReferenceValueTypeId === 101)
        if (alarmFactorUpOilMovementEnd.length === 0) {
          this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue.push({
            SmartReferenceValueTypeId: 101,
            Value: 0,
            MeasurementDateTime: moment().format('YYYY-MM-DD')
          })
        }

        let alarmFactorDownOilMovementEnd = _.filter(this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue, item => item.SmartReferenceValueTypeId === 102)
        if (alarmFactorDownOilMovementEnd.length === 0) {
          this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue.push({
            SmartReferenceValueTypeId: 102,
            Value: 0,
            MeasurementDateTime: moment().format('YYYY-MM-DD')
          })
        }

        let alarmFactorUpOilMovementPressure = _.filter(this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue, item => item.SmartReferenceValueTypeId === 103)
        if (alarmFactorUpOilMovementPressure.length === 0) {
          this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue.push({
            SmartReferenceValueTypeId: 103,
            Value: 0,
            MeasurementDateTime: moment().format('YYYY-MM-DD')
          })
        }

        let warningFactorUpOilMovementPressure = _.filter(this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue, item => item.SmartReferenceValueTypeId === 104)
        if (warningFactorUpOilMovementPressure.length === 0) {
          this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue.push({
            SmartReferenceValueTypeId: 104,
            Value: 0,
            MeasurementDateTime: moment().format('YYYY-MM-DD')
          })
        }

        let warningFactorDownOilMovementPressure = _.filter(this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue, item => item.SmartReferenceValueTypeId === 105)
        if (warningFactorDownOilMovementPressure.length === 0) {
          this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue.push({
            SmartReferenceValueTypeId: 105,
            Value: 0,
            MeasurementDateTime: moment().format('YYYY-MM-DD')
          })
        }

        let alarmFactorDownOilMovementPressure = _.filter(this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue, item => item.SmartReferenceValueTypeId === 106)
        if (alarmFactorDownOilMovementPressure.length === 0) {
          this.smartReferenceSettings[existingObjectIndex].SmartReferenceValue.push({
            SmartReferenceValueTypeId: 106,
            Value: 0,
            MeasurementDateTime: moment().format('YYYY-MM-DD')
          })
        }
      }
    },
    formatDate (event) {
      return moment(event.target.valueAsDate).format('YYYY-MM-DD')
    },
    getSensorUniqueID (railObjectId) {
      let uid = _.filter(this.railObject.PointDrives, item => item.RailObjectId === railObjectId)
      if (uid !== null && uid.length > 0) {
        return uid[0].UniqueId
      }
      return null
    },
    getSensorName (railObjectId) {
      let uid = _.filter(this.railObject.PointDrives, item => item.RailObjectId === railObjectId)
      if (uid !== null && uid.length > 0) {
        return uid[0].Name
      }
      return null
    },
    getPositionSensorValue (settings) {
      settings.forEach(element => {
        if (element.SmartReferenceValueTypeId === 18) {
          return element.Value
        }
      })
      return null
    },
    getSettingsForMotor (uniqueId) {
      let settings = _.filter(this.smartReferenceSettings, item => item.UniqueId === uniqueId)
      return settings
    },
    getSettingsForPositionSensor (railObjectId) {
      let uid = this.getSensorUniqueID(railObjectId)
      let settings = _.filter(this.smartReferenceSettings, item => item.UniqueId === uid && item.SmartReferenceAlgorithmId === 7)
      return settings
    },
    getSettingsForOilPressureSensor (railObjectId) {
      let uid = this.getSensorUniqueID(railObjectId)
      let settings = _.filter(this.smartReferenceSettings, item => item.UniqueId === uid && item.SmartReferenceAlgorithmId === 8)
      return settings
    },
    getExistenceMotorsWithoutUniqueId () {
      return _.filter(this.motors, item => item.UniqueId === null).length > 0
    },
    getSmartReferenceData () {
      let smartReferenceSettingsData = SmartReferenceApi.getSmartReferenceSettingsForRailObject(this.railObject.RailObjectId)
      let smartReferenceSettingsAlgorithmsData = SmartReferenceApi.getSmartReferenceAlgorithms()
      let smartReferenceSettingsTemperatureBinsData = SmartReferenceApi.getSmartReferenceTemperatureBinGroups()
      let smartReferenceSettingsSectionTypesData = SmartReferenceApi.getSmartReferenceSectionTypes()
      let smartReferenceMotorData = SmartReferenceApi.getMotors(this.railObject.RailObjectId)

      var promises = [
        smartReferenceSettingsData,
        smartReferenceSettingsAlgorithmsData,
        smartReferenceSettingsTemperatureBinsData,
        smartReferenceSettingsSectionTypesData,
        smartReferenceMotorData
      ]

      Promise.all(promises).then(values => {
        this.smartReferenceSettings = values[0].data
        this.smartReferenceSettingsAlgorithms = values[1].data
        this.smartReferenceSettingsTemperatureBinGroups = values[2].data
        this.smartReferenceSettingsSectionTypes = values[3].data
        this.motors = values[4].data
        this.loading = false
      })
    },
    getSensor () {
      if (this.railObject.RailObjectId) {
        this.positionsensors = []
        AlarmService.GetSensorsByRailobjectId(this.railObject.RailObjectId).then(result => {
          result.data.forEach(el => {
            if (el.ConfigSensor.UnitOfMeasure !== null && el.ConfigSensor.UnitOfMeasure.toLowerCase() === 'mm'.toLowerCase()) {
              this.positionsensors.push(el)
            }
          })
        })
      }
    },
    getOilPressureSensors () {
      if (this.railObject.RailObjectId) {
        this.oilPressureSensors = []
        AlarmService.GetSensorsByRailobjectId(this.railObject.RailObjectId).then(result => {
          result.data.forEach(el => {
            if (el.ConfigSensor.UnitOfMeasure !== null && el.ConfigSensor.UnitOfMeasure.toLowerCase() === 'bar'.toLowerCase()) {
              this.oilPressureSensors.push(el)
            }
          })
        })
      }
    }
  },
  watch: {
    railObject (val) {
      if (val) {
        this.getSensor()
        this.getOilPressureSensors()
        this.getSmartReferenceData()
      }
    }
  }
}
</script>

<style scoped>
.stripes {
  background-color: rgba(175, 175, 175, 0.1);
}

.select-s1 {
  height: 2rem;
  width: 5rem;
  border: 1px solid rgba(0,0,0,0.2);
}

.select-s2 {
  height: 2rem;
  width: 10rem;
  border: 1px solid rgba(0,0,0,0.2);
}

[type="number"] {
  height: 1.5rem !important;
  width: 4rem !important;
  font-size:12px;
}

[type="date"] {
  height: 1.5rem !important;
  width: 10rem !important;
  font-size:12px;
}

.small-contents {
  /* word-wrap:break-word; */
  font-size:12px;
}

.col.s2 {
    margin-left: 0.9rem;
    width: 10rem;
}

.col.s1 {
    margin-left: 0.9rem;
    width: 5rem;
}

[type="checkbox"]:not(:checked), [type="checkbox"]:checked {
    position: absolute;
}
.invalidInput[type=number] {
  border: 2px solid red; /* Change this to any style you prefer */
}
.Row {
  margin-bottom: 2px;
}
</style>



// WEBPACK FOOTER //
// src/pages/switch/AlarmSettings.vue